<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="60rem" top="8vh" @close="cancel">
    <el-row slot="title" class="center">
      <b v-if="parent"> 子报表编辑</b>
      <small v-if="parent" class="left-pad primary">（父报表：{{ parent.name }}） </small>
      <b v-else>报表编辑</b>
    </el-row>
    <div style="padding: 0 1rem">
      <el-collapse v-model="activePart" accordion>
        <el-collapse-item title=" " name="1">
          <template slot="title">
            <b v-if="activePart == '1'" class="primary">基本信息</b>
            <span v-else>基本信息</span>
          </template>
          <el-form :inline="true" :model="value" :rules="comRules" ref="editor" label-width="8rem" label-position="right" v-loading="loading || saving" :disabled="value.disabled">
            <el-form-item label="名称" prop="name">
              <el-input type="text" class="editor-input" placeholder="请输入" v-model.trim="value.name" size="small" @change="genCode"> </el-input>
            </el-form-item>
            <el-form-item label="编码" prop="code">
              <el-input type="text" class="editor-input" placeholder="请输入" v-model.trim="value.code" :disabled="!!value.id" size="small" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="danger">禁用</span>
              <!-- <el-checkbox v-model="value.disabled" ></el-checkbox> -->
              <el-form>
                <el-switch v-model="value.disabled" />
              </el-form>
            </el-form-item>
            <el-form-item label="应用" prop="sys">
              <hic-dict-selector dict-type="Sys" v-model="value.sys" :disabled="!!parent" />
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <hic-dict-selector dict-type="ReportType" is-enum v-model="value.type" />
            </el-form-item>
            <el-form-item label="数据链接" prop="dbConCode">
              <el-select v-model="value.dbConCode" size="small" filterable>
                <el-option v-for="db in dbCons" :key="db.id" :label="db.name" :value="db.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="打印模板" prop="printTmpl">
              <el-select v-model="value.printTmpl" size="small" filterable>
                <el-option v-for="tmpl in validPrintTmpls" :key="tmpl.id" :label="tmpl.name" :value="tmpl.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="其它">
              <el-checkbox v-model="value.ifPersistence">持久化</el-checkbox>
              <el-checkbox v-model="value.ifPage">分页</el-checkbox>
              <el-checkbox v-model="value.ifSum">合计</el-checkbox>
              <el-checkbox v-model="value.ifNo">序号</el-checkbox>
            </el-form-item>
          </el-form>
        </el-collapse-item>

        <el-collapse-item name="2">
          <template slot="title">
            <b v-if="activePart == '2'" class="primary">数据结构</b>
            <span v-else>数据结构</span>
          </template>
          <el-form :disabled="value.disabled">
            <el-input type="textarea" v-model="value.sql" :rows="5" placeholder="查询SQL，参数请使用 {参数名} 格式" />
            <el-button type="info" size="small" round plain class="top-pad" @click="genReportCols()" icon="el-icon-s-promotion">从SQL自动同步返回值</el-button>
            <el-row v-if="cols.length">
              <el-table :data="cols" size="small">
                <el-table-column label="编码" prop="code"></el-table-column>
                <el-table-column label="名称" prop="name">
                  <template #default="{ row }">
                    <el-input v-model="row.name" size="small" />
                  </template>
                </el-table-column>
                <el-table-column label="值类型" prop="type" align="center">
                  <template #default="{ row }">
                    <hic-dict-selector dictType="DbValueType" is-enum v-model="row.type" size="small" :clearable="false" @change="$set(row, 'dict', null)" />
                  </template>
                </el-table-column>
                <el-table-column label="字典类型" prop="dict" align="center">
                  <template #default="{ row }">
                    <el-row v-if="row.type == '字典'">
                      <!-- <hic-dict-selector dictType="DictType" v-model="row.dict" size="small" :clearable="true" /> -->
                      <el-select v-if="!row.fromParent" v-model="row.dict" size="small" :clearable="true" filterable>
                        <el-option v-for="o in dictTypes" :key="o.code" :label="o.text" :value="o.code" />
                      </el-select>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column label="合计" prop="filterable" align="center">
                  <template #default="{ row }">
                    <el-checkbox v-model="row.summable" size="small" />
                  </template>
                </el-table-column>
                <el-table-column label="过滤" prop="filterable" align="center">
                  <template #default="{ row }">
                    <el-checkbox v-model="row.filterable" size="small" />
                  </template>
                </el-table-column>
                <el-table-column label="排序" prop="sortable" align="center">
                  <template #default="{ row }">
                    <el-checkbox v-model="row.sortable" size="small" />
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-form>
        </el-collapse-item>
        <el-collapse-item title="查询参数" name="3">
          <template slot="title">
            <el-form :disabled="value.disabled">
              <b v-if="activePart == '3'" class="primary">查询参数</b>
              <span v-else>查询参数</span>
              <el-button v-if="activePart == '3'" type="primary" size="mini" circle plain icon="el-icon-plus" class="left-pad" @click.stop="addParam" />
              <el-button v-if="activePart == '3'" type="primary" size="mini" round plain class="left-pad" @click.stop="genParams" icon="el-icon-s-promotion">从SQL自动同步参数</el-button>
            </el-form>
          </template>
          <el-form :disabled="value.disabled">
            <el-table :data="params" height="20rem">
              <el-table-column label="操作" align="center" width="80">
                <template #default="{ row }">
                  <el-tag v-if="row.fromParent" type="info" effect="dark" hit size="mini">父报表</el-tag>
                  <template v-else>
                    <el-button v-if="!row.code && !row.name" type="danger" size="mini" circle plain icon="el-icon-delete" class="left-pad" @click="deleteParam(row)" />
                    <el-popconfirm v-else title="确定删除吗" @confirm="deleteParam(row)">
                      <el-button slot="reference" type="danger" size="mini" circle plain icon="el-icon-delete" class="left-pad" />
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="编码" prop="code" align="center">
                <template #default="{ row }">
                  <el-input v-if="!row.fromParent" v-model="row.code" size="small" />
                  <span v-else>{{ row.code }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" prop="name" align="center">
                <template #default="{ row }">
                  <el-input v-if="!row.fromParent" v-model="row.name" size="small" />
                  <span v-else>{{ row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值类型" prop="valueType" align="center" width="100">
                <template #default="{ row }">
                  <hic-dict-selector v-if="!row.fromParent" dictType="DbValueType" is-enum v-model="row.valueType" size="small" :clearable="false" @change="$set(row, 'dict', null)" />
                  <span v-else>{{ row.valueType }}</span>
                </template>
              </el-table-column>
              <el-table-column label="控件类型" prop="inputType" align="center" width="100">
                <template #default="{ row }">
                  <hic-dict-selector v-if="!row.fromParent" dictType="DbInputType" is-enum v-model="row.inputType" size="small" :clearable="false" />
                  <span v-else>{{ row.inputType }}</span>
                </template>
              </el-table-column>
              <el-table-column label="字典类型" prop="dict" align="center">
                <template #default="{ row }">
                  <el-row v-if="row.valueType == '字典'">
                    <!-- <hic-dict-selector v-if="!row.fromParent" dictType="DictType" v-model="row.dict" size="small" :clearable="true" /> -->
                    <el-select v-if="!row.fromParent" v-model="row.dict" size="small" :clearable="true" filterable>
                      <el-option v-for="o in dictTypes" :key="o.code" :label="o.text" :value="o.code" />
                    </el-select>
                    <span v-else>{{ dictTxt(row.dict) }}</span>
                  </el-row>
                  <!-- <el-row v-else-if="row.valueType == '报表'">
                  <el-select v-if="!row.fromParent" v-model="row.dict" size="small" :clearable="true">
                    <el-option v-for="o in rptDicts" :key="o.id" :label="o.name" :value="o.id"></el-option>
                  </el-select>
                  <span v-else>{{ row.dict }}</span>
                </el-row> -->
                </template>
              </el-table-column>
              <el-table-column label="默认值" prop="defaultValue" align="center">
                <template #default="{ row }">
                  <el-input type="textarea" v-if="!row.fromParent" v-model="row.defaultValue" size="small" />
                  <span v-else>{{ row.defaultValue }}</span>
                </template>
              </el-table-column>
              <el-table-column label="必填" prop="ifRequired" align="center">
                <template #default="{ row }">
                  <el-checkbox v-if="!row.fromParent" v-model="row.ifRequired" size="small" />
                  <span v-else><el-tag v-if="row.ifRequired" type="danger" size="mini" hit> 是</el-tag></span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="saving" :loading="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  import { pinyin as py } from "../../../packages/masterdata";
  export default {
    props: {
      visible: Boolean,
      value: Object,
      parent: Object,
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
          return callback(new Error("编码只能包含：【大小写字母】【数字】【_】【-】"));
        }
        return callback();
      };
      return {
        comRules: {
          name: [
            { required: true, message: "请输入", trigger: "blur" },
            { max: 128, message: "名称长度在 128 个字符以内", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
            { validator: validateCode, trigger: "blur" },
          ],
          sys: [{ required: true, message: "请选择", trigger: "blur" }],
          dbConCode: [{ required: true, message: "请选择", trigger: "blur" }],
        },
        loading: false,
        saving: false,
        sys: {
          items: [],
          curr: null,
        },
        activePart: "1",
        dbCons: [],
        params: [{ code: null, name: null, valueType: null, inputType: null, dict: null, defaultValue: null, ifRequired: false }],
        newReportCode: null,
        activeRpt: "main",
        cols: [],
        rptDicts: [],
        printTmpls: [],
      };
    },
    computed: {
      ...mapGetters(["dict"]),
      dictTypes() {
        let types = [
          {
            code: "Dept",
            text: "科室",
          },
          ...this.rptDicts,
          ...this.dict.DictType,
        ];
        return types;
      },
      validPrintTmpls() {
        if (!this.printTmpls || !this.printTmpls.length || !this.value.sys) {
          return [];
        }
        return this.printTmpls.filter((p) => p.sys == this.value.sys);
      },
    },
    mounted() {
      this.$store.dispatch("loadDicts", "DictType");
      api.Report.query({ type: "字典" }).then((res) => {
        this.rptDicts = res.items.map((i) => ({ code: `rpt_${i.id}`, text: i.name }));
      });
      api.PrintTemplate.query().then((res) => {
        this.printTmpls = res.items;
      });
      this.open();
    },
    methods: {
      open() {
        this.activePart = "1";
        api.DbCon.query().then((res) => {
          this.dbCons = res.items;
        });

        this.params = [];
        if (this.value.params) {
          this.params = JSON.parse(this.value.params);
        }

        // if (this.value.detailSql) {
        //   this.reports = [];
        //   this.reports.push({
        //     code: value.code,
        //     sql: this.value.detailSql,
        //     cols: this.value.detailCol ? JSON.parse(this.value.detailCol) : [],
        //     fixed: true,
        //   });
        // } else {
        //   this.reports = [{ code: "main", fixed: true, sql: null, cols: [] }];
        // }

        this.cols = [];
        if (this.value.cols) {
          this.cols = JSON.parse(this.value.cols);
        }
        if (this.parent) {
          this.params.unshift(...JSON.parse(this.parent.params).map((c) => ({ ...c, fromParent: true })));
        }
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.editor
          .validate()
          .then((valid) => {
            this.saving = true;
            this.value.cols = JSON.stringify(this.cols);
            this.value.params = JSON.stringify(this.params.filter((p) => !p.fromParent && p.code && p.name));
            return api.Report.save(this.value);
          })
          .then((res) => {
            this.$message.success("保存成功！");
            this.$emit("saved", res);
            this.$emit("update:visible", false);
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.saving = false;
          });
      },
      genCode(chns) {
        if (!this.value.id) {
          this.$set(this.value, "code", py.chnToPinYin(chns));
        }
      },
      addParam() {
        this.params.push({ code: null, name: null, valueType: "文本", inputType: "文本", source: null, ifRequired: false });
      },
      saveParam(row) {
        if (!row.code || !row.name) {
          this.$message.warning("参数编码或名称不可以为空！");
          return;
        }
        if (this.params.filter((p) => p.code == row.code).length > 1) {
          this.$message.warning("参数编码不可以重复！");
          return;
        }
      },
      deleteParam(row) {
        this.params.splice(this.params.indexOf(row), 1);
      },
      genReportCols() {
        if (!this.value.sql) {
          return;
        }
        let sql = this.value.sql.replace(/\n/g, " ").replace(/\t/g, "");
        sql = sql.toLowerCase();
        let insertPatten = /insert.*?\((.*?)\)/;
        let selectPatten = /select (.*?) from/;
        let cos = "";
        if (sql.includes("insert")) {
          cos = insertPatten.exec(sql)[1].split(",");
        } else {
          cos = selectPatten.exec(sql)[1].split(",");
        }
        cos = cos
          .filter((c) => !!c)
          .map((c) => {
            let code = c.replace(/"/g, "").replace(/'/g, "").trim();
            if (code.includes(" as ")) {
              code = c.split("as")[1].trim();
            }
            let col = this.cols.find((col) => col.code == code);
            if (col) {
              return col;
            }
            return { code: code, name: code, type: "文本", filterable: false, sortable: false };
          });

        this.cols = cos;
      },
      genParams() {
        if (!this.value.sql) {
          return;
        }
        let sql = this.value.sql.replace(/\n/g, "").replace(/\t/g, "");
        let ps = sql.match(/{.*?}/g);
        if (ps && ps.length) {
          ps = ps.map((p) => p.replace("{", "").replace("}", ""));
          ps.forEach((p) => {
            if (this.params.findIndex((param) => param.code == p) < 0) {
              this.params.push({ code: p, name: p, valueType: "文本", inputType: "文本", source: null, ifRequired: false });
            }
          });
        }
      },
      dictTxt(val) {
        return this.dictTypes.find((d) => d.code == val).text;
      },
    },
  };
</script>
